import React, {Component} from "react";
import axios from 'axios';
import hist from 'middlewares/history';
import PropTypes from "prop-types";
import {MONTHS} from '../../constants';
import {SEARCH_BASE_URL} from "../../config";


import FCHeader from "../../components/Header/FCHeader";
import EntityExtractionHighlighting from "../../components/EntityExtractionHighlighting/EntityExtractionHighlighting";
import EntityExtractionOutputs from "../../components/EntityExtractionOutputs/EntityExtractionOutputs";
import "./style.css"
import CustomLinearProgress from "../../components/CustomLinearProgress/CustomLinearProgress";
import { cardTitle } from "assets/jss/material-kit-pro-react.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import Header from '../../components/Header/Header';
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import EntityExtractionDetails from '../../components/EntityExtractionDetails/EntityExtractionDetails.jsx';

const styles = () => ({
    cardTitle: {
        ...cardTitle,
        color: "#000000 !important"
    },

    visible: {
        "@media screen and (max-width: 600px)":
            {
                display: 'block !important',
            }
    }
})

class DetailsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: +hist.location.pathname.split('/').reverse()[0],
            record: {},
        }
        this.splitJsonForHighlighting = this.splitJsonForHighlighting.bind(this);
    }

    splitJsonForHighlighting() {
        if (Object.keys(this.state.record).length !== 0) {
            return <EntityExtractionHighlighting articleText={this.state.record.content} highlightedTerms={[]}/>
        }
    }

    splitJsonForOutputs() {
        if (Object.keys(this.state.record).length !== 0) {
            return <EntityExtractionOutputs population={this.state.record.pop_group_data}
                                            subjects={this.state.record.subject_data} people={this.state.record.people}
                                            geos={this.state.record.geoname_ids}
                                            organizations={this.state.record.org_profiles}
                                            isControlRequired={true}/>
        }
    }

    splitJsonForDetails() {
        const dateMatch = this.state.record.event_date.match(/(\d{4})-(\d{2})-(\d{2}).*/).slice(-3);
        const pubDateString = `${MONTHS[parseInt(dateMatch[1]) - 1]} ${dateMatch[2]}, ${dateMatch[0]}`;

        if (Object.keys(this.state.record).length !== 0) {

            const title = this.state.record.title ? this.state.record.title : null;
            const site_name = this.state.record.site_name ? `Source: ${this.state.record.site_name}` : null;
            const event_date = this.state.record.event_date ? pubDateString : null;
            const data_id = this.state.record.data_id ? `ID: ${this.state.record.data_id}` : null;
            const is_grant = this.state.record.hasOwnProperty('is_grant') ? `Is grant: ${this.state.record.is_grant}` : null;
            const has_rfp = this.state.record.hasOwnProperty('has_rfp') ? `Has RFP: ${this.state.record.has_rfp}` : null;
            const is_advisory_confidence = this.state.record.hasOwnProperty('model_outputs') && this.state.record.model_outputs.hasOwnProperty('is_advisory_confidence') && this.state.record.model_outputs.is_advisory_confidence ? `Advisory confidence: ${this.state.record.model_outputs.is_advisory_confidence}` : null;
            const is_grant_confidence = this.state.record.hasOwnProperty('model_outputs') && this.state.record.model_outputs.hasOwnProperty('is_grant_confidence') && this.state.record.model_outputs.is_grant_confidence ? `Grant confidence: ${this.state.record.model_outputs.is_grant_confidence}` : null;
            const is_important_confidence = this.state.record.hasOwnProperty('model_outputs') && this.state.record.model_outputs.hasOwnProperty('is_important_confidence')  && this.state.record.model_outputs.is_important_confidence ? `Important confidence: ${this.state.record.model_outputs.is_important_confidence}` : null;
            const is_rfp_confidence = this.state.record.hasOwnProperty('model_outputs') && this.state.record.model_outputs.hasOwnProperty('is_rfp_confidence') && this.state.record.model_outputs.is_rfp_confidence ? `RFP confidence: ${this.state.record.model_outputs.is_rfp_confidence}` : null;
            const is_sector_relevant_confidence = this.state.record.hasOwnProperty('model_outputs') && this.state.record.model_outputs.hasOwnProperty('is_sector_relevant_confidence') && this.state.record.model_outputs.is_sector_relevant_confidence? `Sector relevant confidence: ${this.state.record.model_outputs.is_sector_relevant_confidence}` : null;
            const is_staff_change_confidence = this.state.record.hasOwnProperty('model_outputs') && this.state.record.model_outputs.hasOwnProperty('is_staff_change_confidence') && this.state.record.model_outputs.is_staff_change_confidence ? `Staff change confidence: ${this.state.record.model_outputs.is_staff_change_confidence}` : null;
            const is_trustworthy_confidence = this.state.record.hasOwnProperty('model_outputs') && this.state.record.model_outputs.hasOwnProperty('is_trustworthy_confidence') && this.state.record.model_outputs.is_trustworthy_confidence ? `Trustworthy confidence: ${this.state.record.model_outputs.is_trustworthy_confidence}` : null;

            return {
                title,
                site_name,
                event_date,
                data_id,
                is_grant,
                has_rfp,
                is_advisory_confidence,
                is_grant_confidence,
                is_important_confidence,
                is_rfp_confidence,
                is_sector_relevant_confidence,
                is_staff_change_confidence,
                is_trustworthy_confidence,
            }
        }
    }

    componentDidMount() {
        let payload = {
            route: "id_lookup",
            q: `id:${this.state.id}`
        };
        axios.post(SEARCH_BASE_URL, payload, {withCredentials: true}).then(response => this.setState({record: response.data.records[0]}))
    }


    render() {
        return (
            <React.Fragment>
                {
                    this.state.record && Object.keys(this.state.record).length !== 0 ?
                        <Header
                            color="transparent"
                            brandComponent={
                                <EntityExtractionDetails details = {this.splitJsonForDetails()}/>
                            }
                            rightLinks={<HeaderLinks />}
                            fixed
                            changeColorOnScroll={{
                                height: 200,
                                color: "white"
                            }}
                        /> :
                        <FCHeader/> 
                }
               
                {this.state.record ?
                    <div className={'page'}>
                        <div className={'cards'}>
                            {
                                Object.keys(this.state.record).length !== 0 ?
                                    this.splitJsonForHighlighting() :
                                    null

                            }
                            {
                                Object.keys(this.state.record).length !== 0 ?
                                    this.splitJsonForOutputs() :
                                    null
                            }
                        </div>
                    </div> : <CustomLinearProgress color="primary"/> }
            </React.Fragment>
        )
    }
}

DetailsPage.propTypes = {
    data: PropTypes.array,
    relatedData: PropTypes.array,
    dispatch: PropTypes.func,
    classes: PropTypes.object,
}

export default withStyles(styles)(DetailsPage);


// WEBPACK FOOTER //
// ./src/views/DetailsPage/DetailsPage.jsx